var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    rx: 2,
    fill: "#28C76F",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.013 4.63759H9.33333C9.70167 4.63759 10 4.93593 10 5.30426V8.33259C10 8.69926 9.7 8.99926 9.33333 8.99926H4.66667C4.29833 8.99926 4 8.70093 4 8.33259V4.76293C4 4.48559 4.17167 4.23726 4.43133 4.13926L7.88233 2.83626C8.10033 2.75393 8.33333 2.91493 8.33333 3.14793V4.63726",
    stroke: "#28C76F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33235 6.70768C8.26335 6.70801 8.20768 6.76401 8.20768 6.83301C8.20768 6.90201 8.26368 6.95801 8.33268 6.95768C8.40168 6.95768 8.45768 6.90168 8.45768 6.83268C8.45768 6.76368 8.40168 6.70768 8.33235 6.70768",
    stroke: "#28C76F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletGreen);
export default __webpack_public_path__ + "static/media/wallet_green.5932829520257dd5dc0ae81b41bb00b2.svg";
export { ForwardRef as ReactComponent };